export type Config = {
  baseUrl?: string;
  tenantId?: string;
};

export let config: Config;

let isConfigInitialized = false;
export function initConfig() {
  const id = "app-config-data";
  if (isConfigInitialized && !document.getElementById(id)) return;
  isConfigInitialized = true;
  config = parseConfigFromElement(id, {} as Config);
  return config;
}

export function parseConfigFromElement<T = unknown, Default = T>(
  id: string,
  defaultValue: Default,
): T | Default {
  try {
    const val = JSON.parse(document.getElementById(id)?.textContent ?? "null");
    return val || defaultValue;
  } catch (error) {
    console.error("Failed to parse config from element", error);
    return defaultValue;
  }
}

window.addEventListener("DOMContentLoaded", () => {
  initConfig();
});
